import React from 'react';
import { Text, View } from 'react-native';

interface HeroTagsProps {
  tags?: string[];
}

export function HeroTags({ tags }: HeroTagsProps) {
  if (!tags || tags.length === 0) return null;

  return (
    <View className="flex-row flex-wrap items-center" style={{ gap: 4 }}>
      {tags.map((tag, i) => (
        <React.Fragment key={tag}>
          {i > 0 && (
            <Text style={{ color: 'rgba(242, 240, 235, 0.45)', fontSize: 12 }}>
              {'·'}
            </Text>
          )}
          <Text
            style={{
              color: 'rgba(242, 240, 235, 0.6)',
              fontSize: 13,
            }}
          >
            {tag}
          </Text>
        </React.Fragment>
      ))}
    </View>
  );
}
